<template>
  <div class="d-flex company-content-wrapper" style="height: 100%">
    <CompanyEditMenu :step="step" />
    <div class="l-bg-white">
      <div v-if="step === 'companies-info'">
        <companies-info :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-map'">
        <companies-map :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-settings'">
        <companies-settings :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-pricing'">
        <companies-pricing :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-availability'">
        <companies-availability :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'website-details'">
        <companies-profile :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'web-quote'">
        <companies-web-quote :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-email'">
        <companies-emails :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'getting-started'">
        <companies-getting-started :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-licence'">
        <companies-licence :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'companies-tier'">
        <companies-tier :company="company" type="edit" @saved="saved" />
      </div>
      <div v-if="step === 'billing-info'">
        <companies-billing-info :company="company" type="edit" @saved="saved" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import axios from 'axios';
import CompaniesAvailability from './CompaniesAvailability';
import CompaniesInfo from './CompaniesInfo';
import CompaniesMap from './CompaniesMap';
import CompaniesSettings from './CompaniesSettings';
import CompaniesPricing from './CompaniesPricing';
import CompaniesProfile from './mod24settings/CompaniesProfile';
import CompaniesWebQuote from './CompaniesWebQuote';
import CompanyEditMenu from './CompanyEditMenu';
import CompaniesEmails from './CompaniesEmails';
import CompaniesGettingStarted from './mod24settings/CompaniesGettingStarted';
import CompaniesLicence from './mod24settings/CompaniesLicence';
import CompaniesTier from './mod24settings/CompaniesTier';
import CompaniesBillingInfo from './mod24settings/CompaniesBillingInfo';

export default {
  components: {
    CompaniesBillingInfo,
    CompaniesTier,
    CompaniesLicence,
    CompaniesGettingStarted,
    CompaniesEmails,
    CompanyEditMenu,
    CompaniesAvailability,
    CompaniesInfo,
    CompaniesMap,
    CompaniesSettings,
    CompaniesPricing,
    CompaniesProfile,
    CompaniesWebQuote,
  },
  data() {
    return {
      company: {},
    };
  },
  computed: {
    ...mapState({
      step: state => state.companies.step,
    }),
  },
  mounted() {
    this.loadCompany();
    let companyStep = this.$route.query.tab;
    if (!companyStep) {
      companyStep = 'companies-info';
    }
    this.setCompanyStep(companyStep);
  },
  destroyed() {
    this.setCompanyStep('companies-info');
  },
  methods: {
    ...mapMutations(['setCompany', 'setCompanyStep']),
    saved() {
      this.$store.dispatch('authRefresh');
      this.loadCompany();
    },
    loadCompany() {
      const { id } = this.$route.params;
      axios
        .get(`companies/${id}`)
        .then(res => {
          res.data.data.zip = res.data.data.zip.zip;
          this.company = res.data.data;
          this.setCompany(res.data.data);
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
  },
};
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/companies/CompaniesEdit.vue